export const DEFAULT_COLORS = [
	"#EB144C",
	"#FF3000",
	"#FF6900",
	"#FF8733",
	"#FCB900",
	"#7BDCB5",
	"#00D084",
	"#00DDDD",
	"#8ED1FC",
	"#0693E3",
	"#3663DD",
	"#ABB8C3",
	"#607d8b",
	"#F78DA7",
	"#ee68c8",
	"#ba68c8",
	"#9900EF",
	"#000000",
];
